import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SourcePathPipe } from './source-path-pipe';
import { SafeHtmlPipe } from './safe-html.pipe';
import { FilterAtLogsPipe } from './filter-at-logs.pipe';

@NgModule({
  declarations: [SourcePathPipe, SafeHtmlPipe, FilterAtLogsPipe],
  imports: [CommonModule],
  exports: [SourcePathPipe, SafeHtmlPipe, FilterAtLogsPipe],
})
export class MainPipe {
  public static forRoot(): any {
    return {
      ngModule: MainPipe,
      providers: [],
    };
  }
}
